import { Link } from 'react-router-dom';
import type { ArticleItem } from '@/mocks/articles';

interface ArticleCardProps {
  article: ArticleItem;
  variant?: 'default' | 'featured' | 'compact';
}

export default function ArticleCard({ article, variant = 'default' }: ArticleCardProps) {
  if (variant === 'compact') {
    return (
      <Link to={`/article/${article.id}`} className="group block">
        <article className="flex gap-4 p-3 rounded-xl hover:bg-background-100 transition-colors duration-200">
          <div className="w-24 h-24 flex-shrink-0 rounded-lg overflow-hidden">
            <img
              src={article.image}
              alt={article.title}
              className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
              loading="lazy"
            />
          </div>
          <div className="flex-1 min-w-0">
            <h4 className="text-sm font-semibold text-foreground-950 group-hover:text-primary-500 transition-colors line-clamp-2 mb-2">
              {article.title}
            </h4>
            <div className="flex items-center gap-3 text-xs text-secondary-500">
              <span className="flex items-center gap-1"><i className="ri-eye-line"></i> {(article.views / 10000).toFixed(1)}万</span>
              <span className="flex items-center gap-1"><i className="ri-chat-3-line"></i> {article.comments}</span>
              <span>{article.date}</span>
            </div>
          </div>
        </article>
      </Link>
    );
  }

  return (
    <Link to={`/article/${article.id}`} className="group block">
      <article className="bg-background-50 rounded-xl overflow-hidden border border-background-200/60 hover:border-primary-200 transition-all duration-300">
        <div className="relative aspect-[4/3] overflow-hidden">
          <img
            src={article.image}
            alt={article.title}
            className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
            loading="lazy"
          />
          <div className="absolute top-3 left-3">
            <span className="px-3 py-1 rounded-full text-xs font-medium bg-accent-500 text-background-50">
              {article.category}
            </span>
          </div>
          {article.isHot && (
            <div className="absolute top-3 right-3">
              <span className="px-2 py-1 rounded-full text-xs font-bold bg-primary-500 text-background-50">
                热门
              </span>
            </div>
          )}
        </div>
        <div className="p-4 md:p-5">
          <h3 className="text-base font-semibold text-foreground-950 group-hover:text-primary-500 transition-colors line-clamp-2 mb-3">
            {article.title}
          </h3>
          <p className="text-sm text-secondary-600 line-clamp-2 mb-4 leading-relaxed">
            {article.excerpt}
          </p>
          <div className="flex items-center justify-between text-xs text-secondary-500">
            <div className="flex items-center gap-3">
              <span className="flex items-center gap-1"><i className="ri-eye-line"></i> {(article.views / 10000).toFixed(1)}万</span>
              <span className="flex items-center gap-1"><i className="ri-chat-3-line"></i> {article.comments}</span>
            </div>
            <span>{article.date}</span>
          </div>
        </div>
      </article>
    </Link>
  );
}